export const getDataGridToolbarProps = (overrides = {}) => ({
  showSearch: true,
  showColumnSelector: true,
  showFilter: true,
  showDensity: true,
  showExport: true,
  showPrint: true,
  printTitle: 'Records',
  ...overrides,
});
